import { useQuery } from '@tanstack/react-query'
import { queryCreatives, queryCreativesByAdvertiser, queryCreativeByID } from 'supabase/creatives'

export const useQueryCreatives = () => {
  const query = useQuery({
    queryKey: ['creatives'],
    queryFn: () => queryCreatives(),
  })

  return {
    creatives: query.data || [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  }
}

export const useQueryCreativesByAdvertiser = (advertiserId: string) => {
  const query = useQuery({
    queryKey: ['creatives', 'advertiser', advertiserId],
    queryFn: () => queryCreativesByAdvertiser(advertiserId),
    enabled: !!advertiserId,
  })

  return {
    creatives: query.data || [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  }
}

export const useQueryCreativeByID = (id: string) => {
  const query = useQuery({
    queryKey: ['creative', id],
    queryFn: () => queryCreativeByID(id),
    enabled: !!id,
  })

  return {
    creative: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  }
}